import { render, staticRenderFns } from "./ClueDetails.vue?vue&type=template&id=8bbd03ae&scoped=true&"
import script from "./ClueDetails.vue?vue&type=script&lang=js&"
export * from "./ClueDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClueDetails.vue?vue&type=style&index=0&id=8bbd03ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbd03ae",
  null
  
)

export default component.exports